module.exports = __webpack_public_path__ + "img/isSuccess_1.97944f57.jpg";